import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCrown"><Path d="M4 19.5L1.5 6.5L8 10.5L12 3.5L16 10.5L22.5 6.5L20 19.5H4Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCrown;
